<template>
    <div class="sssssss">
		<header>
			<h1>
				<router-link to="/mine">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">我的收藏</p>
			</h1>
		</header>
		<div class="dd_buti">
			<button class="dd_but" id="dd_butzj">专辑列表</button><button class="dd_buta" id="dd_butlist">章节列表</button>
		</div>
		<!-- 订单 -->
		<!-- 1 -->
		<div class="dd_cntx1">
			<!--  -->
			<div class="dd_cntx" v-for="item in list1">
				<div class="dd_cntxa">
					<img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic" class="dd_cntxaimgax">
					<button class="shoubut" v-on:click="del(item.cl_id)">取消收藏</button>
					<p class="dd_cntxap shouye_dianxxx" id="dd_cntxaf">{{item.b_bookname}}</p>
					<p class="dd_cntxap" id="dd_cntxafa">作者：<span>{{item.b_author}}</span></p>
					<p class="dd_cntxap" id="dd_cntxapl">
						<v-icon name="clone" class="dd_cntxafax"></v-icon>
						{{item.b_partnum}}个章节
					</p>
					<p class="dd_cntxap" id="dd_cntxapr">￥{{item.b_price}}</p>
					<button class="kkkxxx"  @click="bookhref(item.b_id,item.b_is_video)">播放</button>
				</div>
			</div>
			<!--  -->
		</div>
		
		<!-- 2 -->
		<div class="dd_cntx2">
			<!--  -->
			<div class="dd_cntx" v-for="items in list2">
				<div class="dd_cntxa">
					<img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+items.b_pic" class="dd_cntxaimg">
					<button class="shoubut" v-on:click="del(items.cl_id)">取消收藏</button>
					<p class="dd_cntxap shouye_dianxxx" id="dd_cntxaf">{{items.bp_title}}</p>
					<p class="dd_cntxap shouye_dianxxx" id="dd_cntxafa">专辑名：<span>{{items.b_bookname}}</span></p>
					<p class="dd_cntxap shouye_dianxxx" id="dd_cntxxxxxx">
						<v-icon name="play-circle" class="dis_bell"></v-icon>&nbsp;<span>{{items.bp_play_num}}</span>&nbsp;&nbsp;&nbsp;
						<v-icon name="clock" class="dis_clock"></v-icon>&nbsp;<span>{{items.bp_timelength}}</span>
					</p>
					<p class="dd_cntxap" id="dd_cntxapl">
						{{items.money}}{{items.bp_price}}
					</p>
					<p class="dd_cntxap" id="dd_cntxapr">
					<button class="dd_zxcxx" @click="bookhres(items.b_is_video,items.b_id,items.bp_id,items.bp_price)">播放</button>
					</p>
				</div>
			</div>

		</div>
		
		<!-- 订单end -->
		<p class="dd_indexend">已显示全部</p>
		<div class="tc_nav">
	        <span class="tc_navx"></span>
	    </div>
    </div>
</template>
<script>
import appNav from "../common/appNav";
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
	components: {
	  appNav
	},
	data() {
	  return {
	    params: '',
	    list1:[],
	    list2:[],
	  }
	},
	created(){
      var openid=localStorage.getItem("openid");
      this.openid = openid;
   },
	mounted(){
		$('#dd_butzj').click(function(){
			$('.dd_but').css('color','#00a8d9');
			$('.dd_buta').css('color','#000');
			$('.dd_cntx1').show();
			$('.dd_cntx2').hide();
		})
		$('#dd_butlist').click(function(){
			$('.dd_buta').css('color','#00a8d9');
			$('.dd_but').css('color','#000');
			$('.dd_cntx1').hide();
			$('.dd_cntx2').show();
		})
		this.getAjax();
	},
	methods:{
		bookhres (b_is_video,book_id,bp_id,bp_price){
			var openid=localStorage.getItem("openid");
			if(b_is_video == 2){
				var successCallback =  (msg) => {
       			if(bp_price == '0.00'){
//	       			location.href = '/discover/discont/mmm/'+[book_id,bp_id];
	       			this.$router.push({path:'/discover/discont/mmm/'+[book_id,bp_id]})
       			}else{
	       			if(msg.status == 1 || msg.status == 2){
//	                	location.href = '/discover/discont/mmm/'+[book_id,bp_id];
	                	this.$router.push({path:'/discover/discont/mmm/'+[book_id,bp_id]})
	                }else{
//	                	location.href = '/discover/pay/'+[book_id,bp_id,bp_price];
	                	this.$router.push({path:'/discover/pay/'+[book_id,bp_id,bp_price]})
	                }		
       			}
            }
       		var errorCallback =  (msg) => {
                  console.log('error')
            }
       		this.$http.get(CURL+'/portal/All/getzjorder?bp_id='+bp_id+'&openid='+openid,{
              	data:{}
              }).then(successCallback,errorCallback);
				// volume-up 音频
			}else{
				var successCallback =  (response) => {
				var sp = 1
				if(response.status == 2 || response.status == 1 || bp_price == '0.00'){
//					location.href = '/video/playm/'+[book_id,bp_id]
					this.$router.push({path:'/video/playm/'+[book_id,bp_id]})
				}else{
//					location.href = '/discover/pay/'+[book_id,bp_id,bp_price,sp];
					this.$router.push({path:'/discover/pay/'+[book_id,bp_id,bp_price,sp]})
				}

				}
				var errorCallback =  (response) => {
					console.log('errorCallback')
				}
				this.$http.get(CURL+'/portal/All/getzjorder?book_id='+book_id+'&bp_id='+bp_id+'&openid='+openid,{
				data:{}
				}).then(successCallback,errorCallback);
				// tv 视频
			}
		},
		bookhref (e,j) {
			if(j == 2){
//		      location.href = '/discover/discont/'+e
		      this.$router.push({path:'/discover/discont/'+e})
		      // volume-up 音频
		    }else{
//		      location.href = '/video/disv/'+e
		      this.$router.push({path:'/video/disv/'+e})
		      // tv 视频
		    }
		},
	    getAjax:function () {
	     var successCallback =  (response) => {
	        
	        if(response){
	          this.list2 = response.zhangjie
	          this.list1 = response.zhuanji
	          // console.log(this.list2)
	          for(var i=0;i<this.list2.length;i++){
	          	if(this.list2[i].bp_price == '0.00' || this.list2[i].bp_price == '0'){
	          		this.list2[i]['bp_price'] = '免费'
	          	}else{
	          		this.list2[i]['money'] = '￥'
	          	}
	          }
	        }
	      }
	      var errorCallback =  (response) => {
	          console.log('服务器请求出错了')
	      }
	      this.$http.get(CURL+'/portal/all/getcollect?openid='+this.openid,{
	        data:{}
	      }).then(successCallback,errorCallback);
	    },
	    // tz:function (id1,id2) {
	    //    window.location.href="/discover/discont/mmm/"+id1+","+id2
	    // },
	    del:function(id,type){
	    	  var openid=localStorage.getItem("openid")
	    	  var successCallback =  (response) => {
		        // console.log(response)
		        // if(response.status==200){
		        //     $('.tc_navx').text(response.msg)
		        //     $('.tc_nav').fadeIn()
		        //     setTimeout(function(){
		        //         $('.tc_nav').fadeOut()
		                window.location.reload()
		        //     },2000)
		        // }else{
		        // 	$('.tc_navx').text(response.msg)
		        //     $('.tc_nav').fadeIn()
		        //     setTimeout(function(){
		        //         $('.tc_nav').fadeOut()
		        //     },2000)
		        // }
		        // 
		      }
		      var errorCallback =  (response) => {
		          console.log('服务器请求出错了')
		      }
		      this.$http.get(CURL+'/portal/all/getdelecollect?cl_id='+id,{
		        data:{}
		      }).then(successCallback,errorCallback);
    	}
  	}
}



</script>
<style lang="scss" scoped>
.tc_navx{
    background-color: #00a8d9;
    border-radius: 5px;
    padding: 10px 20px 10px 20px;
}
.tc_nav{
    display: none;
    position: fixed;
    margin-left: 20%;
    text-align: center;
    width: 60%;
/*  height: 30px;*/
    color: #ffffff;
    font-size: 15px;
    bottom: 70%;
}
.sssssss{
	background-color: #FFFFFF;
}
.dd_cntxaimgax{
	margin: 5px 0 5px 5px;
	width: 16%;
	float: left;
	height: 85px;
}
.kkkxxx{
	padding: 2px 11px 2px 11px;
	border: #00a8d9 solid 1px;
	color: #00a8d9;
	background-color: inherit;
	border-radius: 15px;
	float: right;
	margin: 10px 0;
}
.dd_zxcxx{
	padding: 2px 11px 2px 11px;
	border: #00a8d9 solid 1px;
	color: #00a8d9;
	background-color: inherit;
	border-radius: 15px;
}
#dd_cntxxxxxx{
	font-size: 12px;
	margin: 0 0 5px 0;
	padding-left: 10px;
	color: #777;
}
.dis_clone,.dis_clock,.dis_bell{
	width: 10px;
	padding-top: 5px;
}
/**/
.shoubut{
	background-color: inherit;
	float: right;
	width: 16%;
	margin-right: 10px;
	margin-top: 12px;
}
/*end*/
.dd_cntx2{
	display: none;
}
.dd_indexend{
	width: 100%;
	float: left;
	margin-top: 50px;
	text-align: center;
	font-size: 15px;
	color: #777;
}
/*cont*/
.dd_cntxafax{
	width: 10px;
	height: 11px;
	color: #999;
}
#dd_cntxafa{
	font-size: 12px;
	margin: 5px 0 5px 0;
	padding-left: 10px;
	color: #777;
}
#dd_cntxaf{
	margin-top: 12px;
	font-size: 13px;
	padding-left: 10px;
}
#dd_cntxapr{
	width: 30%;
	text-align: right;
	font-size: 12px;
	float: right;
/*	padding-right: 10px;*/
}
#dd_cntxapl{
	color: #bad565;
	width: 50%;
	font-size: 12px;
	padding-left: 10px;
	padding-top: 3px;
}
.dd_cntxap{
	width: 50%;
	float: left;
}
.shouye_dianxxx{
  overflow: hidden;
  white-space:nowrap;
  -webkit-text-overflow:ellipsis;
  -moz-text-overflow:ellipsis;
  -o-text-overflow:ellipsis;
  -ms-text-overflow:ellipsis;
  text-overflow:ellipsis;
}
.dd_cntxaimg{
	margin: 11px 0 5px 5px;
	width: 82px;
	height: 110px;
	float: left;
}
.dd_ddh{
	height: 50px;
	line-height: 50px;
	padding-left: 15px;
	color: #777;
}
.dd_cntxa{
	width: 94%;
	background-color: #fafafa;
	float: left;
	margin-left: 3%;
	margin-right: 3%;
	padding-top: 5px;
    padding-bottom: 5px;
}
.dd_cntx{
	margin-top: 15px;
	float: left;
	width: 100%;
}
/*but*/
.dd_but{
	width: 49.5%;
	border-right: #eee solid 1px;
	background-color: #FFFFFF;
	color: #00a8d9;
}
.dd_buta{
	width: 49.5%;
	background-color: #FFFFFF;
}
.dd_buti{
	float: left;
	width: 100%;
	height: 45px;
	line-height: 45px;
	background-color: #FFFFFF;
	border-bottom: #eee solid 2px;
}
/*head*/
header{
  height: .4rem;
  background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
  float: left;
  width: 100%;
  h1{
    margin-top: .2rem;
  }
}
.set_1{
	text-align: center;
    float: left;
    width: 88%;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
    line-height:0;
}
.set_2{
	float: left;
	margin-top: -7px;
	margin-left: 3%;
	width: 5%;
	color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/mine/shouzang.vue